/**
 * The bank domain (backend `TALIA_DOMAIN=bank`, a toy ATM: idle → amount → summary → done, plus error). Everything its
 * screens show and write is the backend's (backend/backend/domains/bank/spec.yaml `ui:` and strings/<lang>.yaml
 * `ui:`): this pack is only its brand and its stage. The proof that a domain on generic widgets is backend only.
 */
import type { DomainPack } from '@platform/packs/contract';
import BANK_UI from './ui.json';

export const bankPack: DomainPack = {
  id: 'bank',
  // for a recording older than `run.domain`: the fields of backend/backend/domains/bank/plugin/session.py
  recognizes: (s) => 'operation' in s && 'amount' in s && 'balance' in s,
  // the bank's brand: teal. Surfaces are the theme's.
  theme: {
    '--brand-accent': '#0f6e6a',
    '--brand-accent-strong': '#0a4b48',
  },
  ui: BANK_UI,
  // the avatar in a bank branch (src/app/stage.json)
  stage: { avatar: 'male_standing', background: 'bank_wall' },
};
